import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./ShortCourseSetup.css";
import { ShortCourseSetup } from './ShortCourseSetupForm';
import ViewUtils from "./../../ViewUtils";
import { ViewContainer } from "./../../View.jsx";
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";


const shortCourseRef = React.createRef();
const toolbarRef = React.createRef();
const utils = new ViewUtils();

class ShortCourse extends Component {

    constructor(props) {
        super(props);

        this.state = {

            ShortCourseSetupDetails: {
                ShortCourseCode: "",
                ShortCourseTitle: "",

            },
            model: {
                OFOOccupationID: null,
                QualificationID: null,
            },
            leadsToQualification: false,
            title: "",
            id: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection)) ? this.props.location.state.selection : null
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: this.props.menuPermissionItem.Edit },
                        { id: 'crm', label: 'CRM', tooltip: 'Client Relations Management', disabled: utils.isNull(this.state.id) },
                    ]
                }
            ]
        }
    }

    handleFormValueChange(values) {
        if (!utils.isNull(values)) {
            let typeId = values.ShortCourseTypeID;

            if (!utils.isNull(typeId) && typeId.Description === "Leads to a Qualification") {
                this.setState({ leadsToQualification: true });
            } else if (!utils.isNull(typeId) && typeId.Description === "Standalone") {
                this.setState({ leadsToQualification: false });
            }

            this.setState({ ShortCourseSetupDetails: values });
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();

        } else if ("close" === buttonId) {
            this.closeView();

        } else if ("crm" === buttonId) {
            this.props.history.push({
                pathname: '/ShortCourseSetupCRM',
                state: {
                    ShortCourseID: !utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection) ? this.props.location.state.selection : this.state.selection,
                    ShortCourseName: this.state.ShortCourseSetupDetails.ShortCourseTitle
                }
            })
        }
    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId !== 0) {
            this.setState({ id: response.EntityId }, () => {
                this.props.history.push({
                    pathname: "/ShortCourseSetup",
                    state: { selection: this.state.id }
                })
                toolbarRef.current.setButtonDisabled("crm", this.state.id === null || response.MessageType === "ERROR")
            })
            shortCourseRef.current.setValue("ShortCourseCode", response.ShortCourseCode);
        }
    }

    save() {

        let formValue = shortCourseRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            let isAdd = true;
            if (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.selection)) {
                formValue.id = this.props.location.state.selection;
                isAdd = false;
            }
            formValue.Document = this.state.Document;
            const data = JSON.stringify(formValue);
            let url = "api/sims/ShortCoursesetupdetails/updateShortCourse";
            if (!isAdd) {
                utils.invokeUrl(url, (response) => {
                    utils.showMessage(this, response.Message, response.MessageType);
                    this.successCallback(response)
                },
                    null,
                    {
                        method: 'PUT',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },
                        body: data
                    }
                )
            } else {
                url = "api/sims/ShortCoursesetupdetails/insertShortCourse";
                utils.invokeUrl(url, (response) => {
                    utils.showMessage(this, response.Message, response.MessageType);
                    this.successCallback(response)
                },
                    null,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        },
                        body: data
                    }
                )
            }
        }
    }

    closeView() {
        this.props.history.push('/ShortCourseSetupSearch');
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">
                <p className="legend">
                    {"Short Course Details"}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    ref={toolbarRef}
                                    title="Short Course"
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    enabled={true} config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "65%", maxHeight: "60vh" }}>
                                    <ShortCourseSetup ref={shortCourseRef}
                                        id={this.state.id !== null ? this.state.id : typeof this.props.location.state !== 'undefined' ? this.props.location.state.selection : null}
                                        valueChangeHandler={(values) => this.handleFormValueChange(values)} data={this.state.model}
                                        leadsToQualification={this.state.leadsToQualification}
                                        editPermission={this.props.menuPermissionItem.Edit}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(ShortCourse));

